export default "__VITE_ASSET__CyopbQTr__"